const PilotNames = [
  'Turner Lighton',
  'Willie Stroker',
  'Dan Druff',
  'Barry Cade',
  'Tim Burr',
  'Dick Burns',
  'Sonny Day',
  'Ted E. Baer',
  'Dick Long',
  'Bill Board',
  'Andy Friese',
  'Al Bino',
  'Chip Munk',
  'Chris P. Bacon',
  'Darren Deeds',
  'Dick Rasch',
  'Jack Pott',
  'Duane Pipe',
  'Gene Poole',
  'Harry Baals',
  'Jack Hoff',
  'Lou Pole',
  'Mike Hunt',
  'Moe B. Dick',
  'Pat Hiscock',
  'Phil Bowles',
  'Ray Gunn',
  'Sal A. Mander',
  'Mike Litoris',
  'Moe Lester',
  'Dick Swett',
  'Sirius Bonner',
  'B. J. Worthy',
  'Harry Hole',
  'Justin Sider',
];
export default PilotNames;
